import { httpClient } from "../../network/httpclient/HttpClientFactory";

const getBimProgress = (bimId) =>
  httpClient.get(`/site/bim/progress/${bimId}`).then((res) => res.data);

const getBimProgressCounts = () =>
  httpClient.get(`/site/bim/progress`).then((res) => res.data);

const save = (param) => httpClient.put(`/site`, param).then((res) => res.data);

const detail = () => httpClient.get(`/site`).then((res) => res.data);

const getProgress = () =>
  httpClient.get(`/site/progress`).then((res) => res.data);

const deleteProgress = (id) =>
  httpClient.delete(`/site/progress/${id}`).then((res) => res.data);

const saveBimProgress = (param) =>
  httpClient.post(`/site/bim/progress`, param).then((res) => res.data);

/* [2023/12/14] added by yhj */
const getBimType = (bimId) =>
  httpClient.get(`/site/bim/type/${bimId}`).then((res) => res.data);

export default {
  getBimProgress,
  save,
  detail,
  getBimProgressCounts,

  getProgress,
  deleteProgress,
  saveBimProgress,

  /* [2023/12/14] added by yhj */
  getBimType,
};
